/**
 * Created by Paul on 6/5/2017.
 */
import {Component, Input} from '@angular/core';
import {SixMarkBaseComponent} from "../sixMarkBase";

@Component({
  selector: 'sm-three-parts',
  templateUrl: './sixmarkThreeParts.html',
  styleUrls: [ '/sixmarkThreeParts.scss' ]
})

/**
 * mname: SM03
 * The game includes 3 parts:
 * 1. List of number from 0 to 9
 * 2. Big button options
 * 3. Small button options
 */
export class SixMarkThreePartsComponent extends SixMarkBaseComponent {
  // List of numbers - each has value and isActive props
  numbers = [];

  // List of button options - Check out in sixmark.ts for structure
  betOptions = [];

  @Input()
  set selectOption(selectOption: any) {
    if (selectOption) {
      this.numbers = selectOption.no.numbers;
      this.betOptions = selectOption.no.betOptions;

      this.maxAmountPerOption = selectOption.no.maxAmountPerOption;
      this.maxAmountPerBet = selectOption.no.maxAmountPerBet;
      this._selectOption = selectOption;
    }
  }

  /**
   * Get either number option or button option by code
   * @param code
   */
  getOptionByCode(code: string) {
    // Check if input code is in numbers array
    let selectedOption = this.numbers.find(numberOption => numberOption.code === code);

    if (!selectedOption) {
      let n: number = this.betOptions.length;
      for (let i = 0; i < n; i++) {
        selectedOption = this.betOptions[i].options.find(option => option.code === code);
        if (selectedOption)
          return selectedOption;
      }
    }

    return selectedOption;
  }

  /**
   * Reset all status to the beginning of the game
   */
  resetGame() {
    // Reset numbers status
    this.resetBetCoins(this.numbers);

    // Reset button options status
    this.betOptions.forEach(betOption => {
      this.resetBetCoins(betOption.options);
    });

    // Reset total
    this.onTotalChanged.emit(0);
  }

  /**
   * Remove a specific bets
   * @param bets
   */
  removeBets(bets = []) {
    bets.forEach(code => {
      // Get option by code
      let option = this.getOptionByCode(code);

      if (option && option.betCoins) {
        option.betCoins.pop();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/component/sixmark/threeParts/sixmarkThreeParts.ts